"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ = require("./");

var _luxon = require("luxon");

class BackgroundCheck {
  static thaw(backgroundCheckObj) {
    if (backgroundCheckObj == null) return null;
    const backgroundCheck = new BackgroundCheck();
    if (backgroundCheckObj.id != null) backgroundCheck.setId(backgroundCheckObj.id);
    if (backgroundCheckObj.invitationId != null) backgroundCheck.setInvitationId(backgroundCheckObj.invitationId);
    if (backgroundCheckObj.reportId != null) backgroundCheck.setReportId(backgroundCheckObj.reportId);
    if (backgroundCheckObj.reportStatus != null) backgroundCheck.setReportStatus(backgroundCheckObj.reportStatus);
    if (backgroundCheckObj.invitationStatus != null) backgroundCheck.setInvitationStatus(backgroundCheckObj.invitationStatus);
    if (backgroundCheckObj.reportResult != null) backgroundCheck.setReportResult(backgroundCheckObj.reportResult);
    if (backgroundCheckObj.reportAdjudication != null) backgroundCheck.setReportAdjudication(backgroundCheckObj.reportAdjudication);
    if (backgroundCheckObj.hasPassed != null) backgroundCheck.setHasPassed(backgroundCheckObj.hasPassed);
    if (backgroundCheckObj.evaluator != null) backgroundCheck.setEvaluator(_.Evaluator.thaw(backgroundCheckObj.evaluator));
    if (backgroundCheckObj.createdAt != null) backgroundCheck.setCreatedAt(_luxon.DateTime.fromISO(backgroundCheckObj.createdAt));
    if (backgroundCheckObj.updatedAt != null) backgroundCheck.setUpdatedAt(_luxon.DateTime.fromISO(backgroundCheckObj.updatedAt));
    return backgroundCheck;
  }

  static thawList(backgroundCheckObjList) {
    if (backgroundCheckObjList == null) return [];
    var backgroundCheckes = [];

    for (var i = 0; i < backgroundCheckObjList.length; i++) {
      backgroundCheckes.push(BackgroundCheck.thaw(backgroundCheckObjList[i]));
    }

    return backgroundCheckes;
  }

  static freeze(backgroundCheck) {
    if (backgroundCheck == null) return null;
    var backgroundCheckObj = {};
    if (backgroundCheck.getId() != null) backgroundCheckObj.id = backgroundCheck.getId();
    if (backgroundCheck.getInvitationId() != null) backgroundCheckObj.invitationId = backgroundCheck.getInvitationId();
    if (backgroundCheck.getReportId() != null) backgroundCheckObj.reportId = backgroundCheck.getReportId();
    if (backgroundCheck.getReportStatus() != null) backgroundCheckObj.reportStatus = backgroundCheck.getReportStatus();
    if (backgroundCheck.getInvitationStatus() != null) backgroundCheckObj.invitationStatus = backgroundCheck.getInvitationStatus();
    if (backgroundCheck.getReportResult() != null) backgroundCheckObj.reportResult = backgroundCheck.getReportResult();
    if (backgroundCheck.getReportAdjudication() != null) backgroundCheckObj.reportAdjudication = backgroundCheck.getReportAdjudication();
    if (backgroundCheck.getHasPassed() != null) backgroundCheckObj.hasPassed = backgroundCheck.getHasPassed();
    if (backgroundCheck.getEvaluator() != null) backgroundCheckObj.evaluator = backgroundCheck.getEvaluator();
    if (backgroundCheck.getCreatedAt() != null) backgroundCheckObj.createdAt = backgroundCheck.getCreatedAt();
    if (backgroundCheck.getUpdatedAt() != null) backgroundCheckObj.updatedAt = backgroundCheck.getUpdatedAt();
    return backgroundCheckObj;
  }

  static freezeList(backgroundCheckes) {
    if (backgroundCheckes == null) return [];
    var backgroundCheckObjList = [];

    for (var i = 0; i < backgroundCheckes.length; i++) {
      backgroundCheckObjList.push(BackgroundCheck.freeze(backgroundCheckes[i]));
    }

    return backgroundCheckObjList;
  }

  constructor() {
    this.setId(null);
    this.setInvitationId(null);
    this.setReportId(null);
    this.setReportStatus(null);
    this.setInvitationStatus(null);
    this.setReportResult(null);
    this.setReportAdjudication(null);
    this.setHasPassed(null);
    this.setEvaluator(null);
    this.setCreatedAt(null);
    this.setUpdatedAt(null);
  }
  /* -------------------------
     -------------------------
     -------- SETTERS --------
     -------------------------
     ------------------------- */


  setId(id) {
    this.id = id;
  }

  setInvitationId(invitationId) {
    this.invitationId = invitationId;
  }

  setReportId(reportId) {
    this.reportId = reportId;
  }

  setReportStatus(reportStatus) {
    this.reportStatus = reportStatus;
  }

  setInvitationStatus(invitationStatus) {
    this.invitationStatus = invitationStatus;
  }

  setReportResult(reportResult) {
    this.reportResult = reportResult;
  }

  setReportAdjudication(reportAdjudication) {
    this.reportAdjudication = reportAdjudication;
  }

  setHasPassed(hasPassed) {
    this.hasPassed = hasPassed;
  }

  setEvaluator(evaluator) {
    this.evaluator = evaluator;
  }

  setCreatedAt(createdAt) {
    this.createdAt = createdAt;
  }

  setUpdatedAt(updatedAt) {
    this.updatedAt = updatedAt;
  }
  /* -------------------------
     -------------------------
     -------- GETTERS --------
     -------------------------
     ------------------------- */


  getId() {
    return this.id;
  }

  getInvitationId() {
    return this.invitationId;
  }

  getReportId() {
    return this.reportId;
  }

  getReportStatus() {
    return this.reportStatus;
  }

  getInvitationStatus() {
    return this.invitationStatus;
  }

  getReportResult() {
    return this.reportResult;
  }

  getReportAdjudication() {
    return this.reportAdjudication;
  }

  getHasPassed() {
    return this.hasPassed;
  }

  getEvaluator() {
    return this.evaluator;
  }

  getCreatedAt() {
    return this.createdAt;
  }

  getUpdatedAt() {
    return this.updatedAt;
  }
  /* -------------------------
     -------------------------
     -------- HELPERS --------
     -------------------------
     ------------------------- */


}

exports.default = BackgroundCheck;